<template>
  <fragment>
    <a ref="attachmentA"></a>
    <!-- End Infobar Setting Sidebar -->
    <div class="row">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-header row">
            <div class="col">
              <h5 class="card-title mb-0" v-if="!currentFilter">Filtri</h5>
              <h5 class="card-title mb-0" v-if="currentFilter">
                {{ currentFilter.description }}
              </h5>
            </div>
            <div class="col text-right">
              <button
                class="btn btn-info-rgba"
                id="infobar-settings-open"
                v-if="userFilters.length > 0"
              >
                <i class="feather icon-save mr-2"></i>I Miei filtri
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col">
                <input
                  type="text"
                  v-model="query"
                  class="form-control mb-2"
                  placeholder="Codice/ragione sociale/telefono/email"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-11">
                <taglist v-model="tags" :readOnlyReserved="false"></taglist>
              </div>
              <div class="col-1">
                <select class="form-control" v-model="tagoperator">
                  <option value="AND">AND</option>
                  <option value="OR">OR</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col text-right mt-2">
                <button
                  class="btn btn-primary-rgba mr-4"
                  v-on:click="savefilter"
                  v-if="!currentFilter"
                >
                  <i class="feather icon-save mr-2"></i>Salva Filtro
                </button>
                <div class="btn-group" v-if="currentFilter">
                  <button
                    type="button"
                    class="btn btn-primary-rgba dropdown-toggle mr-4"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="feather icon-save mr-2"></i>Salva filtro
                  </button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" v-on:click="savefilter(false)"
                      >Salva le modifiche di "{{
                        currentFilter.description
                      }}"</a
                    >
                    <a class="dropdown-item" v-on:click="savefilter(true)"
                      >Salva con nome</a
                    >
                  </div>
                </div>

                <button class="btn btn-primary-rgba mr-2" v-on:click="loaddata">
                  <i class="feather icon-filter mr-2"></i>Ricerca
                </button>

                <button class="btn btn-danger-rgba" v-on:click="resetdata">
                  <i class="feather icon-delete mr-2"></i>Elimina filtro
                </button>

                <button
                  class="btn btn-info-rgba ml-5"
                  v-if="$store.getters.isInRole('company-export')"
                  v-on:click="excel"
                >
                  <i class="fa fa-file-excel-o mr-2"></i>Esporta ricerca
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="card m-b-30">
          <div class="card-body">
            <router-link
              v-if="false"
              class="btn btn-sm btn-primary"
              :to="{
                name: 'route-company-edit',
                params: { id: '00000000-0000-0000-0000-000000000000' },
              }"
            >
              <font-awesome-icon icon="plus-circle"></font-awesome-icon>Aggiungi
              nuovo cliente
            </router-link>

            <table
              ref="table"
              id="list-company-table"
              class="table w-100"
            ></table>
          </div>
        </div>
      </div>
    </div>
    <sidebarUserFilter
      ref="usidebar"
      @filters="refreshFilters"
      @setFilter="setFilter"
    />
    <!-- /.col -->
  </fragment>
</template>

<script>
import axios from "axios";
export default {
  computed: {},
  components: {},
  data() {
    return {
      tags: [],
      query: "",
      tagoperator: "OR",
      currentFilter: null,
      userFilters: [],
    };
  },
  name: "CompanyList",
  beforeMount() {
    var me = this;
    window.ViewMessage = function (id) {
      me.$router.push({
        name: "route-message",
        params: { id: id },
        replace: true,
      });

      return false;
    };
  },

  mounted() {
    var me = this;
    if (localStorage.getItem("company-list-query"))
      me.query = localStorage.getItem("company-list-query");
    if (localStorage.getItem("company-list-tags"))
      me.tags = JSON.parse(localStorage.getItem("company-list-tags"));
    if (localStorage.getItem("company-list-tagoperator"))
      me.tagoperator = localStorage.getItem("company-list-tagoperator");

    if (localStorage.getItem("company-userfilter"))
      me.currentFilter = JSON.parse(localStorage.getItem("company-userfilter"));
    setTimeout(this.loaddata, 200);
  },
  methods: {
    edit: function (id) {
      this.$router.push({ name: "route-company-edit", params: { id: id } });
      return false;
    },
    resetdata() {
      this.query = "";
      this.tags = [];
      (this.tagoperator = "OR"), (this.currentFilter = null);
      localStorage.removeItem("company-userfilter");
      this.loaddata();
    },
    setFilter(filter) {
      if(!filter) return;
      this.currentFilter = filter;
    
      this.query = this.currentFilter.filterConfiguration.searchQuery || "";
      this.tags = this.currentFilter.filterConfiguration.searchTags || [];
      this.tagoperator =
        this.currentFilter.filterConfiguration.searchOperation || "OR";
      localStorage.setItem(
        "company-userfilter",
        JSON.stringify(this.currentFilter)
      );
      this.loaddata();
    },
    refreshFilters(filters) {
      if (this.currentFilter != null) {
        var exists = false;
        for (var i; i < filters.length; i++) {
          if (filters[i].userFilterId == this.currentFilter.userFilterId) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          this.currentFilter = null;
          localStorage.removeItem("company-userfilter");
        }
      }

      this.userFilters = filters;
    },

    savefilter(newFilter) {
      var me = this;
      console.log(this.currentFilter);
      if (this.currentFilter != null) {
        if (newFilter) {
          this.currentFilter.userFilterId =
            "00000000-0000-0000-0000-000000000000";
          this.$swal({
            title: `Salvataggio filtro`,
            html: `Dai un nome al tuo filtro`,
            input: "text",
            inputPlaceholder: "Nome filtro",
            showCancelButton: true,
            confirmButtonClass: "btn-warning-rgba",
            confirmButtonText: "Procedi",
            cancelButtonText: "Annulla",
            inputValidator: (value) => {
              if (!value) {
                return "Immettere il nome del filtro";
              }
            },
          }).then(function (value) {
            if (value.dismiss) {
              return;
            }
            me.currentFilter.description = value.value;
            me.$refs.usidebar.saveFilter(me.currentFilter);
          });
        } else {
          me.$refs.usidebar.saveFilter(me.currentFilter);
        }
      }

      if (this.currentFilter == null) {
        this.$swal({
          title: `Salvataggio filtro`,
          html: `Dai un nome al tuo filtro`,
          input: "text",
          inputPlaceholder: "Nome filtro",
          showCancelButton: true,
          confirmButtonClass: "btn-warning-rgba",
          confirmButtonText: "Procedi",
          cancelButtonText: "Annulla",
          inputValidator: (value) => {
            if (!value) {
              return "Immettere un nome filtro";
            }
          },
        }).then(function (value) {
          if (value.dismiss) {
            return;
          }

          me.$refs.usidebar.saveFilter({
            description: value.value,
            filterConfiguration: {
              searchTags: me.tags,
              searchQuery: me.query,
              searchOperation: me.tagOperator,
            },
          });
        });
      }
    },
    loaddata: function () {
      //console.log("usidebar",this.$refs.usidebar.loaddata);
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-company-table")) {
        $("#list-company-table").DataTable().destroy();
      }

      var $table = $("#list-company-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/company/list",
          type: "POST",
          data: function (d) {
            localStorage.setItem("company-list-query", me.query);
            localStorage.setItem("company-list-tagoperator", me.tagoperator);
            localStorage.setItem("company-list-tags", JSON.stringify(me.tags));
            d.search.value = me.query;
            d.tagOperator = me.tagoperator;
            d.filters = [
              {
                key: "tags",
                value: JSON.stringify(me.tags),
              },
            ];
            d.tago;

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "companyId",
            name: "companyId",
            title: "Codice",
            render: function (data, type, row, meta) {
              return row.internalCode;
            },
          },
          {
            data: "companyId",
            name: "companyId",
            title: "Azienda",
            render: function (data, type, row, meta) {
              return row.name;
            },
          },
          {
            className: "text-right",
            data: "companyId",
            name: "companyId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              if (row.isImported) {
              }
              return `<div class="button-list"><button type="button" class="btn btn-info-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-info"></i></button>`;
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },
        ],
      });

      $table.on("select", function (e, dt, type, indexes) {});
    },
    excel: function () {
      var me = this;
      var o = "ExportUtenti.xlsx";
      var data = {
        search: { value: this.query },
        tagOperator: this.tagoperator,
        filters: [
          {
            key: "tags",
            value: JSON.stringify(this.tags),
          },
        ],
      };
      axios
        .post("company/excel", data, { responseType: "blob" })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
  },
};
</script>
